import { Button, type ButtonProps } from "./Button";

export interface IconButtonProps extends Omit<ButtonProps, "size" | "aria-label" | "children"> {
  /** Accessible name; icon-only buttons must have one. */
  label: string;
  size?: "sm" | "md";
  children: React.ReactNode;
}

/** A square button for a single icon. `label` becomes its accessible name. */
export function IconButton({ label, size = "md", variant = "ghost", ...props }: IconButtonProps) {
  return (
    <Button
      data-slot="icon-button"
      aria-label={label}
      title={label}
      variant={variant}
      size={size === "sm" ? "icon-sm" : "icon"}
      {...props}
    />
  );
}
